import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsMultiProfile extends Layout {
    layoutCollections: Layout;
    sourceCollectionsProfile: DataSource;
    tabProfile: Tab;
    tabsetCollectionsProfiles: Tabset;
}
